import { render } from "./ReciboVenda.vue?vue&type=template&id=68a29309&scoped=true"
import script from "./ReciboVenda.vue?vue&type=script&lang=js"
export * from "./ReciboVenda.vue?vue&type=script&lang=js"

import "./ReciboVenda.vue?vue&type=style&index=0&id=68a29309&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a29309"]])

export default __exports__